import { render, staticRenderFns } from "./WhatAreYouHaving.vue?vue&type=template&id=2435c7d6&"
import script from "./WhatAreYouHaving.vue?vue&type=script&lang=ts&"
export * from "./WhatAreYouHaving.vue?vue&type=script&lang=ts&"
import style0 from "./WhatAreYouHaving.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports